// extracted by mini-css-extract-plugin
export default {"bucketAdminContent":"AdminBucket_bucketAdminContent__K4TJ9"};